<template>
  <article class="item">
    <a :href="'/activity/' + item._id" class="content">
      <div class="picture">
        <img :src="item._source.imageUrl" alt="">
      </div>
      <div class="heading">
        <h3>{{ item._source.title }}</h3>
      </div>
      <div class="info">
        <p class="date">
          <i class="fa fa-calendar"></i>
          {{ getDate(item._source.dates) }}
        </p>
        <p class="address">
          <i class="fa fa-map-marker"></i>
          {{ truncate(item._source.address, 10) }}
        </p>
        <p class="price" v-show="item._source.canBePurchased  && item._source.firstType.price !== null">
          Desde {{ item._source.currency == 'PEN' ? 'S/. ' : '$ ' }} {{ item._source.firstType.price }}
        </p>
      </div>
      <div :class="'action ' + (!item._source.canBePurchased ? 'gray' : (item._source.firstType.price > 0 ? 'red' : 'green'))">
        <span>
          {{ !item._source.canBePurchased ? 'VER INFORMACIÓN' : (item._source.firstType.price > 0 ? 'COMPRAR ENTRADAS' : 'GRATIS') }}
        </span>
      </div>
    </a>
  </article>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      weekDays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
    }
  },
  created () {
  },
  methods: {
    replaceAll (search, replace, str) {
      return str.split(search).join(replace)
    },

    getDate (dates) {
      let dateStart = new Date(this.replaceAll('-', '/', dates[0].start))
      for (let i = 1; i < dates.length; i++) {
        let date = new Date(this.replaceAll('-', '/', dates[i].start))

        if (date < dateStart) {
          dateStart = date
        }
      }

      // let year = dateStart.getFullYear()
      let month = dateStart.getMonth()
      let day = dateStart.getDate()
      let weekDay = dateStart.getDay()
      let h = dateStart.getHours()
      let m = this.addZero(dateStart.getMinutes())
      let ampm = h >= 12 ? 'p.m.' : 'a.m.'
      h = h % 12
      h = h || 12

      return this.weekDays[weekDay] + ' ' + day + ' de ' + this.months[month] + ', ' + h + ':' + m + ' ' + ampm
    },

    addZero: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },

    truncate (str, length) {
      str = str.split(' ')
      let more = ''
      if (str.length > length) {
        more = '...'
      }
      return str.splice(0, length).join(' ') + more
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EventCard.vue